import { __decorate } from "tslib";
import { LitElement, html, customElement, internalProperty } from 'lit-element';
import '@cds/core/forms/register.js';
import '@cds/core/toggle/register.js';
import '../lib/grid.element';
import './demo.static';
import './demo.grid-compact';
import './demo.cell-editable';
import './demo.cell-keyboard';
import './demo.column-fixed';
import './demo.column-sticky';
import './demo.column-show-hide';
import './demo.column-sortable';
import './demo.kitchen-sink';
import './demo.static-loop';
import './demo.footer';
import './demo.pagination';
import './demo.detail-view';
import './demo.placeholder';
import './demo.performance';
import './demo.no-scroll';
import './demo.row-draggable';
import './demo.row-filtering';
import './demo.row-multi-action';
import './demo.row-multi-select';
import './demo.row-single-select';
import './demo.row-single-action';
import './demo.row-swappable';
let App = class App extends LitElement {
    constructor() {
        super(...arguments);
        this.showDemos = true;
    }
    render() {
        return html `
      <div cds-layout="vertical gap:lg p:lg">
        <cds-toggle-group layout="vertical-inline">
          <cds-toggle>
            <label>dark theme</label>
            <input type="checkbox" @click=${this.toggleTheme} />
          </cds-toggle>
          <cds-toggle>
            <label>toggle demos</label>
            <input type="checkbox" @click=${this.toggleDemos} ?checked=${this.showDemos} />
          </cds-toggle>
        </cds-toggle-group>

        ${this.showDemos ? html `
        <!-- <section cds-layout="grid cols:12 gap:lg">
          <demo-static></demo-static>
        </section> -->
        <section cds-layout="grid cols@lg:6 cols@xl:4 gap:lg">
          <div>
            <h2 cds-text="section">Keyboard Navigation</h2>
            <demo-keyboard></demo-keyboard>
          </div>
          <div>
            <h2 cds-text="section">Kitchen Sink</h2>
            <demo-kitchen-sink></demo-kitchen-sink>
          </div>
          <div>
            <h2 cds-text="section">Static</h2>
            <demo-static></demo-static>
          </div>
          <div>
            <h2 cds-text="section">Pagination</h2>
            <demo-pagination></demo-pagination>
          </div>
          <div>
            <h2 cds-text="section">Show Hide Columns</h2>
            <demo-show-hide-columns></demo-show-hide-columns>
          </div>
          <div>
            <h2 cds-text="section">Detail View</h2>
            <demo-detail-view></demo-detail-view>
          </div>
          <div>
            <h2 cds-text="section">Single Select</h2>
            <demo-single-select></demo-single-select>
          </div>
          <div>
            <h2 cds-text="section">Multi Select</h2>
            <demo-multi-select></demo-multi-select>
          </div>
          <div>
            <h2 cds-text="section">Single Action</h2>
            <demo-single-action></demo-single-action>
          </div>
          <div>
            <h2 cds-text="section">Multi Action</h2>
            <demo-multi-action></demo-multi-action>
          </div>
          <div>
            <h2 cds-text="section">Sortable Rows</h2>
            <demo-sortable></demo-sortable>
          </div>
          <div>
            <h2 cds-text="section">Filtering</h2>
            <demo-filtering></demo-filtering>
          </div>
          <div>
            <h2 cds-text="section">Pinned Columns</h2>
            <demo-col-fixed></demo-col-fixed>
          </div>
          <div>
            <h2 cds-text="section">Sticky Columns</h2>
            <demo-col-sticky></demo-col-sticky>
          </div>
          <div>
            <h2 cds-text="section">Editable</h2>
            <demo-editable></demo-editable>
          </div>
          <div>
            <h2 cds-text="section">Placeholder</h2>
            <demo-placeholder></demo-placeholder>
          </div>
          <div>
            <h2 cds-text="section">Optional Footer</h2>
            <demo-footer></demo-footer>
          </div>
          <div>
            <h2 cds-text="section">Compact</h2>
            <demo-grid-compact></demo-grid-compact>
          </div>
          <div>
            <h2 cds-text="section">Performance</h2>
            <demo-performance></demo-performance>
          </div>
          <div>
            <h2 cds-text="section">Draggable Rows</h2>
            <demo-draggable-rows></demo-draggable-rows>
          </div>
          <div>
            <h2 cds-text="section">Swappable Rows</h2>
            <demo-swappable-rows></demo-swappable-rows>
          </div>
          <div>
            <h2 cds-text="section">No Scroll</h2>
            <demo-no-scroll></demo-no-scroll>
          </div>
        </section>
        ` : ''}
      </div>
    `;
    }
    toggleTheme(e) {
        document.body.setAttribute('cds-theme', e.target.checked ? 'dark' : '');
    }
    toggleDemos() {
        this.showDemos = !this.showDemos;
    }
    createRenderRoot() {
        return this;
    }
};
__decorate([
    internalProperty()
], App.prototype, "showDemos", void 0);
App = __decorate([
    customElement('app-root')
], App);
export { App };
//# sourceMappingURL=index.js.map